/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable react/button-has-type */
/* eslint-disable react/no-unknown-property */
import React from 'react';
import { useSelector } from 'react-redux';
import BookedFlight from './BookedFlight/BookedFlight';

function BookedFlights() {
  const flights = useSelector(state => state.flights);
  // console.log(flights);
  return (
    <div className="table-container">
      <table className="booking-table">
        <thead className="bg-gray-100/50">
          <tr className="text-black text-left">
            <th>Destination From</th>
            <th>Destination To</th>
            <th className="text-center">Journey Date</th>
            <th className="text-center">Guests</th>
            <th className="text-center">Class</th>
            <th className="text-center">Delete</th>
          </tr>
        </thead>
        <tbody className="divide-y divide-gray-300/20" id="lws-previewBooked">
          {flights.map(flight => (
            <BookedFlight key={flight.id} flight={flight} />
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default BookedFlights;
